import React, { Component } from 'react'
import { TABLE_DISTRIBUCION_POR_CEREAL } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDistribucionPorCerealView extends Component {
  render () {
    return (
      <MuiTable id={TABLE_DISTRIBUCION_POR_CEREAL} />
    )
  }
}
